<template>
    <div>
        <router-view></router-view>
        <portal-target name="modals" multiple></portal-target>
    </div>
</template>

<script>
    export default {
    };
</script>
